import {NIcon} from 'naive-ui';
import {type Component, h} from "vue";

export const renderIcon = (icon: Component, props: any = null) => {
    return () => {
        return h(NIcon, props, {
            default: () => h(icon)
        })
    }
}
